import { render } from "./FooterCom.vue?vue&type=template&id=cae64f60&scoped=true"
import script from "./FooterCom.vue?vue&type=script&lang=js"
export * from "./FooterCom.vue?vue&type=script&lang=js"

import "./FooterCom.vue?vue&type=style&index=0&id=cae64f60&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cae64f60"]])

export default __exports__